import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=6a52bb4d&scoped=true&"
import script from "./nft.vue?vue&type=script&lang=js&"
export * from "./nft.vue?vue&type=script&lang=js&"
import style0 from "./nft.vue?vue&type=style&index=0&id=6a52bb4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a52bb4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a52bb4d')) {
      api.createRecord('6a52bb4d', component.options)
    } else {
      api.reload('6a52bb4d', component.options)
    }
    module.hot.accept("./nft.vue?vue&type=template&id=6a52bb4d&scoped=true&", function () {
      api.rerender('6a52bb4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/nft.vue"
export default component.exports